import { Box, Button, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";



export const ModalContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  maxWidth: "800px",
  gap: "25px",
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down("desktop")]: {
    width: "100%",
  },
}));

export const ModalBodyMB2 = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: "flex"
}));

export const SuperScript = styled("sup")(() => ({
  position: "relative",
  fontSize: 10,
  bottom: 2.3,
}));

export const EventDescription = styled(Typography)(({ theme }) => ({
  color: theme.colors.neutral.darkGray,
  marginBottom: theme.spacing(3),
  display: "-webkit-box",
  overflow: "hidden",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  paddingBottom: theme.spacing(2),
}));

export const EventDetailsTitle = styled(Typography)(({ theme }) => ({
  display: "-webkit-box",
  overflow: "hidden",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  marginBottom: "10px"
}));